/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoCreateAccountRequest model module.
 * @module model/ManagerControllerDtoCreateAccountRequest
 * @version 1.0
 */
class ManagerControllerDtoCreateAccountRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoCreateAccountRequest</code>.
     * @alias module:model/ManagerControllerDtoCreateAccountRequest
     * @param name {String} 
     * @param email {String} 
     * @param groupNo {Number} 
     * @param departmentNo {Number} 
     */
    constructor(name, email, groupNo, departmentNo) { 
        
        ManagerControllerDtoCreateAccountRequest.initialize(this, name, email, groupNo, departmentNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, email, groupNo, departmentNo) { 
        obj['name'] = name;
        obj['email'] = email;
        obj['groupNo'] = groupNo;
        obj['departmentNo'] = departmentNo;
    }

    /**
     * Constructs a <code>ManagerControllerDtoCreateAccountRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoCreateAccountRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoCreateAccountRequest} The populated <code>ManagerControllerDtoCreateAccountRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoCreateAccountRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
            if (data.hasOwnProperty('departmentNo')) {
                obj['departmentNo'] = ApiClient.convertToType(data['departmentNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoCreateAccountRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoCreateAccountRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoCreateAccountRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

ManagerControllerDtoCreateAccountRequest.RequiredProperties = ["name", "email", "groupNo", "departmentNo"];

/**
 * @member {String} name
 */
ManagerControllerDtoCreateAccountRequest.prototype['name'] = undefined;

/**
 * @member {String} email
 */
ManagerControllerDtoCreateAccountRequest.prototype['email'] = undefined;

/**
 * @member {Number} groupNo
 */
ManagerControllerDtoCreateAccountRequest.prototype['groupNo'] = undefined;

/**
 * @member {Number} departmentNo
 */
ManagerControllerDtoCreateAccountRequest.prototype['departmentNo'] = undefined;






export default ManagerControllerDtoCreateAccountRequest;

